<div
  ngbDropdown
  [placement]="['bottom-end', 'top-end']"
  class="btn-group"
  appClickStopPropagation
  #dropdownContainer
  (openChange)="onDropdownOpenChange($event)"
>
  <button ngbDropdownToggle class="btn btn-negative p-1 no-focus d-flex hover-bg-gray-200" id="actionsDropdown" data-testid="actionsToggle">
    <i class="icon ni-more-horiz"></i>
  </button>
  <div ngbDropdownMenu class="dropdown-menu p-0 shadow" aria-labelledby="actionsDropdown">
    @if (!row.isProfileComplete && row.isActive) {
      <button
        ngbDropdownItem
        class="d-flex align-items-center btn btn-secondary border-bottom no-outline"
        (click)="onResendPasswordLink(row.id)"
        data-testid="resendPasswordLink"
      >
        <i class="icon ni-send me-2"></i>
        <span>{{ 'MANAGED_USERS.RESEND_PASSWORD_LINK' | translate }}</span>
      </button>
    }

    @if (row.isActive) {
      <button
        ngbDropdownItem
        class="d-flex align-items-center btn btn-secondary border-bottom no-outline"
        (click)="onBlockUser()"
        data-testid="blockUser"
      >
        <i class="icon ni-not-interested me-2"></i>
        <span>{{ 'MANAGED_USERS.BLOCK_ACCOUNT' | translate }}</span>
      </button>
    } @else {
      <button
        ngbDropdownItem
        class="d-flex align-items-center btn btn-secondary border-bottom no-outline"
        (click)="onUnblockUser()"
        data-testid="unblockUser"
      >
        <i class="icon ni-check-circle-outlined me-2"></i>
        <span>{{ 'MANAGED_USERS.UNBLOCK_ACCOUNT' | translate }}</span>
      </button>
    }
  </div>
</div>
